import { ActionTypes, TypeKeys } from './actions';
import { ErrorTypes, processSteps } from '../../services/upload/UploadService';

export interface FileInfo {
    fileName: string;
    fileType: string;
    fileSize: string;
}

export interface ProgressPayload {
    uploadProgress: number;
    uploadProgressTime: any;
    uploadProgressEstimatedMsRemaining: any;
}

export interface FileUploadedPayload {
    fileDownloadUrl: string;
    uploadCompletedAt: Date;
    fileInfo: FileInfo;
}

export interface UploadState {
    callbackMessages: any[];
    currentStep: processSteps;
    isInitialRender: boolean;
    error: ErrorTypes;
    fileInfo: any;
    savedFileContentItemId: any;
    selectedFile: File;
    uploadProgress: number;
    uploadProgressTime: any;
    uploadProgressEstimatedMsRemaining: any;
    uploadStartedAt: any;
    uploadCompletedAt: any;
    uploadedFileS3Name: any;
    fileDownloadUrl: string;
    ticket: string;
}

const initialState: UploadState = {
    callbackMessages: [],
    currentStep: processSteps.INITIAL,
    isInitialRender: true,
    error: undefined,
    fileInfo: undefined,
    savedFileContentItemId: undefined,
    selectedFile: undefined,
    uploadProgress: 0,
    uploadProgressTime: undefined,
    uploadProgressEstimatedMsRemaining: undefined,
    uploadStartedAt: undefined,
    uploadCompletedAt: undefined,
    uploadedFileS3Name: undefined,
    fileDownloadUrl: undefined,
    ticket: undefined,
};

export const fileUploadReducer = (state: UploadState = { ...{}, ...initialState }, action: ActionTypes): UploadState => {
    switch (action.type) {
    case TypeKeys.HANDLE_CANCELLED:
        return {
            ...state,
            currentStep: processSteps.INITIAL,
        };
    case TypeKeys.HANDLE_ERROR:
        return {
            ...state,
            error: action.error,
            currentStep: processSteps.ERROR,
        };
    case TypeKeys.HANDLE_PROGRESS:
        return {
            ...state,
            uploadProgress: action.data.uploadProgress,
            uploadProgressTime: action.data.uploadProgressTime,
            uploadProgressEstimatedMsRemaining: action.data.uploadProgressEstimatedMsRemaining,
        };
    case TypeKeys.HANDLE_FILE_UPLOAD:
        return {
            ...state,
            selectedFile: action.selectedFile,
            uploadStartedAt: action.uploadStartedAt,
            ticket: action.ticket,
            currentStep: processSteps.FILE_UPLOADING,
        };
    case TypeKeys.HANDLE_FILE_UPLOAD_COMPLETED:
        return {
            ...state,
            uploadedFileS3Name: action.uploadedFileS3Name,
            currentStep: processSteps.FILE_UPLOADED,
        };
    case TypeKeys.SET_CALLBACK_MESSAGES:
        return {
            ...state,
            callbackMessages: action.data,
        };
    case TypeKeys.REMOVE_UPLOAD:
        return {
            ...initialState,
        };
    default:
        return state;
    }
};
